import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@duoduo-oba/ng-devui/utils';
import { DataTableColumnTmplComponent } from './tmpl/data-table-column-tmpl.component';

@Pipe({ name: 'disPlayCellValuePipe' })
export class DisPlayCellValuePipe implements PipeTransform {
  datePickerCN = {
    locale: 'zh-CN',
    timePicker: false,
    current: 'ä»å¤©',
    confirmTime: 'ç¡®å®',
    dateConverter: null, // DateConverter
    weeks: ['æ¥', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­'],
    months: ['ä¸æ',
      'äºæ',
      'ä¸æ',
      'åæ',
      'äºæ',
      'å­æ',
      'ä¸æ',
      'å«æ',
      'ä¹æ',
      'åæ',
      'åä¸æ',
      'åäºæ'],
    min: 1900,
    max: 2099,
    format: {
      date: 'YYYY-MM-DD',
      time: 'YYYY-MM-DD HH:mm'
    }
  };

  constructor() { }
  transform(rowItem, rowIndex, column: DataTableColumnTmplComponent): any {
    if (!column || !column.field) {
      return null;
    }

    if (column.field === '$index') {
      return rowIndex + 1;
    }

    const cellItem = rowItem[column.field];

    switch (column.fieldType) {
      case 'date':
        let pattern;
        if (column.extraOptions && column.extraOptions.dateFormat) {
          pattern = column.extraOptions.dateFormat;
        } else {
          pattern = column.extraOptions && column.extraOptions.showTime ?
            this.datePickerCN.format.time : this.datePickerCN.format.date;
        }
        return cellItem ? formatDate(new Date(cellItem), pattern) : '';
      case 'select':
      case 'treeSelect':
        if (column.extraOptions && column.extraOptions.multiple) {
          if (cellItem && cellItem.length > 0) {
            let displayValue;
            if (column.extraOptions.filterKey) {
              displayValue = cellItem.map(item => item[column.extraOptions.filterKey]).join(';');
            } else {
              displayValue = cellItem.join(';');
            }
            return displayValue;
          } else {
            return '--';
          }
        } else {
          let displayValue;
          if (column.extraOptions && column.extraOptions.filterKey) {
            displayValue = cellItem ? cellItem[column.extraOptions.filterKey] : cellItem;
          } else {
            displayValue = cellItem;
          }
          return displayValue === 0 ? 0 : (displayValue || '--');
        }
      default:
        return cellItem === 0 ? 0 : (cellItem || '--');
    }
  }
}
